var mpRequest = false;
var mpRedirect = false;

function multipassLoginHandler(el) {
  var button = el.querySelector('button[type="submit"]');

  button.addEventListener('click', function(e) {
    e.stopPropagation();
    e.preventDefault();
    if (mpRequest || mpRedirect) {
      return;
    }

    var email = el.querySelector('input[type="email"]').value;
    var password = el.querySelector('input[name="customer[password]"]').value;

    var http = new XMLHttpRequest();
    var url = '/apps/multipass?time=' + Date.now();
    var body = JSON.stringify({
      locale: Shopify.locale,
      endpoint: 'login',
      password: password,
      email: email,
    });

    http.open('POST', url, true);
    http.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    http.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    http.setRequestHeader('Cache-Control', 'no-cache, no-store, max-age=0');
    http.setRequestHeader('Expires', 'Thu, 1 Jan 1970 00:00:00 GMT');
    http.setRequestHeader('Pragma', 'no-cache');

    http.onreadystatechange = function() {
      if (mpRedirect) {
        return false;
      }
      el.classList.remove('processing');
      el.setAttribute('disabled', false);
      if (http.status == 200 && http.responseText) {
        var data = JSON.parse(http.responseText);
        if (data.success) {
          mpRedirect = true;
          localStorage.setItem('multipass', '1');
          window.location = window.location.origin + '/account/login/multipass/' + data.token;
          return;
        }
        el.submit();
        mpRequest = false
      } else if (http.status !== 200) {
        el.submit();
        mpRequest = false
      }
    }

    el.classList.add('processing');
    el.setAttribute('disabled', true);
    mpRequest = true;
    http.send(body);
  });
}

if (document.readyState !== 'loading') {
  initIDServer();
} else {
  document.addEventListener('DOMContentLoaded', function() {
    initIDServer();
  });
}

function initIDServer() {
  Array.from(document.querySelectorAll('form#customer_login')).forEach(function (el) {
    multipassLoginHandler(el);
  });
  Array.from(document.querySelectorAll('form#login')).forEach(function (el) {
    multipassLoginHandler(el);
  });

  if (localStorage.getItem('multipass') == '1') {
    localStorage.removeItem('multipass');
    fetch("/cart/update.json", {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            note: ''
        })
    });
  }
}
